{
  "de": {
    "courseCatalog": {
      "activeCourses": {
        "title": "Aktive Fortbildungen",
        "toCourse": "Zum Kurs"
      },
      "headers": {
        "title": "Entdecke praxisnahe Weiterbildungen"
      },
      "filters": {
        "courseType": "Kurstyp",
        "subjectAreas": "Themenbereiche",
        "languages": "Sprache",
        "order": {
          "label": "Sortierung",
          "relevant": "Relevanz",
          "mostRecent": "Neueste",
          "rating": "Bewertung",
          "popular": "Beliebtheit"
        }
      },
      "courseTypes": {
        "courses": "Fortbildungen",
        "webinar": "Live-Webinare",
        "recording": "Aufzeichnungen",
        "impulse": "Impulse"
      },
      "sections": {
        "liveWebinars": "Live-Webinare",
        "liveWebinarsDescription": "Nimm an Vorträgen von Expert*innen mit Diskussionsräumen und der Möglichkeit zum Austausch teil.",
        "newCourses": "Neue Kurse",
        "pinned": "fobizz Favoriten",
        "pinnedDescription": "Besonders beliebte und relevante Kurse - die aktuellen Empfehlungen der fobizz Redaktion.",
        "impulses": "Impulse",
        "impulsesDescription": "Erhalte kompakte, praxisnahe Einblicke in neue Themen & Unterrichtsideen - in unter 30 Minuten.",
        "courses": "Fortbildungen",
        "coursesDescription": "Lerne in deinem Tempo, wann du willst und wo du willst - besuche Selbstlernkurse mit hohem Praxisbezug.",
        "recommendations": "Persönliche Kursempfehlungen",
        "recommendationsDescription": "Eine Auswahl besonders relevanter Kurse für dich, auf Basis deiner Profilangaben und deiner bereits belegten oder gemerkten Kurse.",
        "recordings": "Webinar-Aufzeichnungen",
        "recordingsDescription": "Verfolge vergangene Live-Webinare anhand der Aufzeichnungen und vertiefe dein Wissen ganz flexibel."
      },
      "links": {
        "showAllWebinars": "Alle Live-Webinare anzeigen",
        "showAllCourses": "Alle Fortbildungen anzeigen",
        "showAllImpulses": "Alle Impulse anzeigen",
        "showAllRecordings": "Alle Webinar-Aufzeichnungen anzeigen"
      },
      "search": {
        "placeholder": "Fortbildungen durchsuchen...",
        "noResults": "Leider haben wir keine Kurse mit diesen Suchkriterien gefunden."
      },
      "subjectAreas": {
        "subject_area_didactic": "Didaktik & Unterrichtsdesign",
        "subject_area_media_education": "Medienkompetenz & Medienkritik",
        "subject_area_collaboration": "Team- und Beziehungsarbeit",
        "subject_area_school_development": "Schulentwicklung & Leadership",
        "subject_area_performance": "Leistung, Feedback & Lernstand",
        "subject_area_diversity": "Inklusion, Differenzierung & Sprachbildung",
        "subject_area_health": "Gesundheit & Professionalisierung",
        "subject_area_ki": "Künstliche Intelligenz",
        "subject_area_tools": "Digitale Tools & Anwendungen",
        "subject_area_kids_world": "Schülerinnenwelten & Gesellschaft",
        "subject_area_chances": "Startchancen",
        "subject_area_programming": "Programmieren & Informatik"
      },
      "teaser": {
        "title": "Erhalte individuelle Fortbildungs-Empfehlungen",
        "linkName": "Zum KI-Fortbildungsfinder"
      },
      "languages": {
        "de": "Deutsch",
        "en": "Englisch",
        "fr": "Französisch",
        "es": "Spanisch"
      }
    }
  }
}
